import React from 'react'
import styled from 'styled-components/macro'
import { rem } from '../../utils/styles'
import CallToActionTitle from './CallToActionTitle'
import CallToActionWrapper from './CallToActionWrapper'

export const CallToActionBase = styled.aside`
  text-align: center;
  margin: ${rem(40)} 0;
`

function CallToAction({ title, children }) {
  return (
    <CallToActionBase>
      {title && (
        <CallToActionTitle
          as='h3'
          size='small'
        >
          {title}
        </CallToActionTitle>
      )}
      <CallToActionWrapper>
        {children}
      </CallToActionWrapper>
    </CallToActionBase>
  )
}

export default CallToAction
